import { useEffect, useRef } from 'preact/hooks'
import type { ChatConfig, Message, UiTexts } from '../../types/chat'
import ChatMessage from '../ChatMessage'
import styles from './ChatMessages.module.css'

interface Props {
  config: ChatConfig
  texts: UiTexts
  messages: Message[]
  isTyping: boolean
}

export default function ChatMessages({ config, texts, messages, isTyping }: Props) {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const reduce = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
    // block: 'nearest' scrolls only the message list, never the host page.
    bottomRef.current?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' })
  }, [messages, isTyping])

  return (
    <div className={styles.messages} data-part="messages" role="log" aria-live="polite" aria-label={texts.messagesLabel}>
      {messages.map((msg) => (
        <ChatMessage key={msg.id} message={msg} config={config} texts={texts} />
      ))}

      {isTyping && (
        <div className={styles.typingRow} data-part="typing">
          <div className={styles.miniAvatar} aria-hidden="true">
            {config.botAvatarUrl ? (
              <img src={config.botAvatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : null}
          </div>
          <div className={styles.typingBubble}>
            <span className={styles.typingDots} aria-hidden="true">
              <span className={styles.dot} />
              <span className={styles.dot} />
              <span className={styles.dot} />
            </span>
            <span className="bc-sr-only">{texts.typing}</span>
          </div>
        </div>
      )}

      <div ref={bottomRef} />
    </div>
  )
}
